import { Link } from "react-router-dom";

import withLayoutOptions from "../../components/withLayoutOptions/withLayoutOptions";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageKidF.module.scss";

function PageKidF() {
  const getImgSet = useImgSet();

  const notice = getImgSet("notice__p08", "png");
  const item01 = getImgSet("item__01__p08", "png", [s.item, s.item__01]);
  const item02 = getImgSet("item__02__p08", "png", [s.item, s.item__02]);
  const pointer = getImgSet("pointer__kid", "png", s.pointer);

  const back = getImgSet("back__p22", "png");
  const imgA = getImgSet("bear__03", "png", s.img__a);

  return (
    <div className={s.root}>
      {pointer}
      <div className={s.aside_left}>
        <Link to="/kid/" className={s.back}>
          {back}
        </Link>
        {imgA}
        <Link to="/kid/g" className={s.notice}>
          {notice}
        </Link>
      </div>
      <div className={s.inner}>
        {item01}
        {item02}
      </div>
      <div />
    </div>
  );
}

export default withLayoutOptions(PageKidF);
